<template>
    <div class="lg:grid lg:grid-cols-12 lg:gap-x-10 overflow-x-scroll  shadow sm:rounded-md">
        <section class="lg:col-span-12">
            <div class="bg-white pt-6">
                <div class="px-4 sm:px-6">
                    <h2 class="text-lg leading-6 font-medium text-gray-900">Transactions</h2>
                </div>
                <div class="flex flex-col mt-6">
                    <div class="-my-2 sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead class="bg-gray-50">
                                    <tr>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">Date</th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">Reference</th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">Doc Number</th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-16">Description</th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">Amount</th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider break-words">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
<!--                                    <tr>-->
<!--                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">-->
<!--                                            {{ beginningBalance.balance_date | niceDate }}-->
<!--                                        </td>-->
<!--                                        <td class="px-6 py-4 text-gray-500 text-sm">-->
<!--                                            Beginning Balance-->
<!--                                        </td>-->
<!--                                        <td class="px-6 py-4 text-gray-500 text-sm">-->
<!--                                        </td>-->
<!--                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">-->
<!--                                            Beginning Balance-->
<!--                                        </td>-->
<!--                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-right">-->
<!--                                            <span v-if="beginningBalance.balance >= 0" class="text-gray-500">{{ beginningBalance.balance | currency }}</span>-->
<!--                                            <span v-if="beginningBalance.balance < 0" class="text-red-500">{{ beginningBalance.balance | currency }}</span>-->
<!--                                        </td>-->
<!--                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">-->
<!--                                            {{ beginningBalance.balance | currency }}-->
<!--                                        </td>-->
<!--                                    </tr>-->
                                    <tr v-for="(item, idx) in items">
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                            {{ item.transaction_date | niceDate }}
                                        </td>
                                        <td class="px-6 py-4 text-gray-500 text-sm">
                                            {{ item.reference }}
                                        </td>
                                        <td class="px-6 py-4 text-gray-500 text-sm">
                                            {{ item.document_number }}
                                        </td>
                                        <td class="px-6 py-4 text-xs text-gray-500 w-16">
                                            {{ item.description }}
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-right">
                                            <span v-if="item.transaction_amount >= 0" class="text-gray-500">{{ item.transaction_amount | currency }}</span>
                                            <span v-if="item.transaction_amount < 0" class="text-red-500">{{ item.transaction_amount | currency }}</span>
                                        </td>
                                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                                            {{ item.running_total | currency }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div v-if="items.length === 0" class="text-center text-gray-400 text-lg p-8">No current items...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script>

import TableHead from '@/Components/DataTable/TableHead'

export default {
    components: {TableHead},
    props: {
        items: {
            type: Array,
            default: []
        },
        beginningBalance: {
            type: Object,
        }
    },
    data() {
        return {
            filteredItems: [],
            showFilter: false,
            sortKey: 'transaction_date',
            sortOrder: 'asc',
            searchOptions: {},
            runningTotals: []
        }
    },
    mounted() {
        // this.items.push({
        //     'transaction_date': this.beginningBalance.balance_date,
        //     'transaction_amount': this.beginningBalance.balance,
        //     'description': 'Beginning Balance',
        //     'reference': 'Beginning Balance',
        // })

        // this.items.sort(
        //     this.compareValues(this.sortKey, this.sortOrder)
        // )

        // this.items.map((item, index) => {
        //     let items =this.items.slice(0, index)
        //
        //     if (item.description === 'Beginning Balance') {
        //         item.running_total = item.transaction_amount
        //     } else {
        //         item['running_total'] = items.reduce((acc, curr) => acc + Number(curr.transaction_amount), 0) * -1
        //         item['running_total'] = item['running_total'] <= 0 ? item['running_total'] * -1 : item['running_total']
        //     }
        //
        //
        //     return item
        // })

        // let runningBalance = 0;
        //
        // this.items.map((item, index) => {
        //     if (item.description === 'Beginning Balance') {
        //         runningBalance = Number(item.transaction_amount);
        //     } else {
        //         runningBalance += Number(item.transaction_amount);
        //     }
        //
        //     item.running_total = runningBalance;
        //
        //     return item;
        // });

        this.items.sort(
            this.compareValues(this.sortKey, 'desc')
        )

        // this.filteredItems = this.items
        //
        // this.sortOrder = 'desc'
    },
    methods: {
        runningBalance(idx) {
            let items = this.sortedItems.slice(0, idx+1)
            let itemsTotal = items.reduce((acc, curr) => acc + Number(curr.transaction_amount), 0)
            return Number(this.beginningBalance.balance) + itemsTotal
        },
        setShowMenu(id) {
            this.showMenu = this.showMenu === id ? null : id
        },
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].toString().localeCompare(b[key], undefined);
                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        },
        currentDate() {
            let dateObj = new Date()
            let monthName = dateObj.toLocaleString("default", { month: "long" })
            let year = dateObj.getFullYear()
            return monthName + ' ' + year
        }
    },
    // computed: {
    //     sortedItems() {
    //         return this.items.sort(
    //             this.compareValues(this.sortKey, this.sortOrder)
    //         )
    //     }
    // },
    // watch: {
    //     items: {
    //         handler: function (val) {
    //             this.filteredItems = val
    //         },
    //         deep: true
    //     }
    // }
}
</script>
